export default __webpack_public_path__ + "static/media/kraft.e7fde32d.svg";